import { createReducer } from 'redux-create-reducer';
import { addFilter, removeFilter } from 'features/helpers';
import { ACTIONS } from '../constants';

export const INITIAL_STATE = {
  data: null,
  showOptionsModal: false,
  lastPage: 1,
  isFetchingFeed: false,
  isRefreshing: false,
  isExporting: false,
  includeSpecialZones: false,
  filters: [],
  shipTypes: []
};

const setShipTypes = (state, { shipTypes }) => ({
  ...state,
  shipTypes: Array.isArray(shipTypes) ? shipTypes : [], 
});

const addShipType = (state, { shipType }) => {
  // Avoid adding duplicates
  if (state.shipTypes.includes(shipType)) {
    return state;
  }
  return {
    ...state,
    shipTypes: [...state.shipTypes, shipType], 
  };
};

const removeShipType = (state, { shipType }) => ({
  ...state,
  shipTypes: state.shipTypes.filter(type => type !== shipType),
});



const setIsFetchingFeed = (state, isFetchingFeed) => ({
  ...state,
  isFetchingFeed,
});


const setToggleIncludeSpecialZones = state => ({
  ...state,
  includeSpecialZones: !state.includeSpecialZones,
});


const setLoadInventoryAtsSuccess = (state, { payload }) => ({
  ...state,
  data: payload,
  isFetchingFeed: false,
  isRefreshing: false,
});

const setLoadInventoryAtsError = state => ({
  ...state,
  isFetchingFeed: false,
  isRefreshing: false,
});

const setShowOptionsModal = (state, { showOptionsModal }) => ({
  ...state,
  showOptionsModal,
});

const updateLastPage = (state, { lastPage }) => ({
  ...state,
  lastPage,
});

const setIsRefreshing = (state, isRefreshing) => ({
  ...state,
  isRefreshing,
});

const resetLastPage = state => ({
  ...state,
  lastPage: INITIAL_STATE.lastPage,
});

const setIsExporting = (state, isExporting) => ({
  ...state,
  isExporting,
});

const updateFilters = (state, filters) => ({
  ...state,
  filters,
});

const addFilterOperand = (state, { operand }) => {
  const updatedFilters = addFilter(operand, state.filters);
  return {
    ...updateFilters(state, updatedFilters),
    lastPage: INITIAL_STATE.lastPage,
  };
};

const removeFilterOperand = (state, { groupIndex, filterIndex }) => {
  const updatedFilters = removeFilter(groupIndex, filterIndex, state.filters);
  return {
    ...updateFilters(state, updatedFilters),
    lastPage: INITIAL_STATE.lastPage,
  };
};

const setFiltersList = (state, { filters }) => updateFilters(state, filters);

const resetState = () => ({ ...INITIAL_STATE });

export const handlers = {
  [ACTIONS.LOAD_FEED]: state => setIsFetchingFeed(state, true),
  [ACTIONS.LOAD_INVENTORY_ATS]: state => setIsFetchingFeed(state, true),
  [ACTIONS.LOAD_INVENTORY_ATS_SUCCESS]: setLoadInventoryAtsSuccess,
  [ACTIONS.LOAD_INVENTORY_ATS_ERROR]: setLoadInventoryAtsError,
  [ACTIONS.SHOW_OPTIONS_MODAL]: setShowOptionsModal,
  [ACTIONS.GO_TO_PAGE]: updateLastPage,
  [ACTIONS.REFRESH_INVENTORY_FEED]: state => setIsRefreshing(state, true),
  [ACTIONS.TOGGLE_INCLUDE_SPECIAL_ZONES]: setToggleIncludeSpecialZones,
  [ACTIONS.SET_ITEMS_PER_PAGE]: resetLastPage,
  [ACTIONS.SET_FILTER_OPERAND]: addFilterOperand,
  [ACTIONS.UNSET_FILTER_OPERAND]: removeFilterOperand,
  [ACTIONS.CLEAR_FILTERS]: state => updateFilters(state, INITIAL_STATE.filters),
  [ACTIONS.SET_FILTERS]: setFiltersList,
    
  [ACTIONS.SET_SHIP_TYPES]: setShipTypes,
  [ACTIONS.ADD_SHIP_TYPE]: addShipType,
  [ACTIONS.REMOVE_SHIP_TYPE]: removeShipType,

  [ACTIONS.EXPORT_TO_FILE]: state => setIsExporting(state, true),
  [ACTIONS.EXPORT_TO_FILE_SUCCESS]: state => setIsExporting(state, false),
  [ACTIONS.EXPORT_TO_FILE_ERROR]: state => setIsExporting(state, false),
  

  [ACTIONS.EXIT_CONTAINER]: resetState,
};

export default createReducer(INITIAL_STATE, handlers);
